module.exports = __webpack_public_path__ + "img/礼物-1.35b202af.png";